module.exports = __webpack_public_path__ + "static/media/new-york-74.e34542bb.jpg";